import React, { ReactNode, useEffect, useState } from 'react'
import { Button, Modal, TextInput } from '../../../index.js'
import { FileInput } from '../../FileInput/index.js'
import { useUploadFile } from '../../../hooks/useUploadFile.js'

export const AddImageModal = ({
  children,
  defaultCaption = '',
  onSave,
  mode = 'add',
  urlOnly,
}: {
  children?: ReactNode
  mode?: 'add' | 'edit'
  defaultCaption?: string
  onSave: (value: { file: { src: string }; caption: string }) => void
  urlOnly?: boolean
}) => {
  const [file, setFile] = useState<{ src: string } | null>(null)
  const [caption, setCaption] = useState(defaultCaption)
  const [url, setUrl] = useState('')
  const { handleFileInputChange, status, progress, newSrc } = useUploadFile()

  return (
    <Modal title={mode === 'add' ? 'Add image' : 'Edit image'}>
      <Modal.Trigger>{children}</Modal.Trigger>
      <Modal.Content>
        <Modal.Body>
          {urlOnly ? (
            <TextInput
              value={url}
              onChange={(v) => {
                setUrl(v)
                setFile({ src: v })
              }}
              label="Image url"
            />
          ) : (
            <FileInput
              multiple={false}
              label="Upload a file"
              stream="file-upload"
              description="Description of the file input"
              onChange={handleFileInputChange((file) => {
                setFile({ src: file.src })
              })}
            />
          )}
          {/* <TextAreaInput
                value={caption}
                onChange={setCaption}
                label="Caption"
              /> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="border" onClick={() => Modal.Close()}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onSave({ file, caption })
              Modal.Close()
            }}
          >
            {mode === 'add' ? 'Add' : 'Save changes'}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
